
import styled from 'styled-components';

const TableContainerYounet = styled.div`
    min-height:${props=>props.minHeight ? props.minHeight : '70vh'};
    max-height:${props=>props.maxHeight ? props.maxHeight : '70vh'};
    overflow-x: auto;
    width:${props=> props.width ? props.width : 'auto'};
    &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        border: none;
        border-radius:3em;
    };
    &::-webkit-scrollbar-track { 
        background-image: radial-gradient(circle, rgba(214,236,241,0.465721322708771) 0%, rgba(162,201,247,0.4853291658460259) 100%);
        background-size:contain;
        background-repeat:no-repeat;
        border-radius:3em;
    };
    &::-webkit-scrollbar-thumb {
        background-size: contain;
        background-repeat: no-repeat;
        background-image: linear-gradient(90deg, rgba(36,93,212,1) 0%, rgba(15,90,180,1) 100%);
        border-radius: 3em;
    };
`;

const TableYounet = styled.table`
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    border-width: 0px;
    border-style: solid;
    border-color: grey;
`;

const TheadYounetStyledFixed = styled.th`
    text-align:${props => props.align ? props.align : 'left'};    
    min-width:${props => props.width || 100};
    width:${props => props.width || 100};
    background-color:${props => props.bgColor ? props.bgColor : '#0E3B5F'};
    color: #fff;
    display:block;
    font-weight:bold;
    height:33px;
    max-height:33px;
    padding-left:10px;
    padding-top:6px;
    position:sticky;
    z-index:1; 
    left:${props => props.left || '0px'};
`;

const TheadYounetStyled = styled.th`
    text-align:${props => props.align ? props.align : 'left'};
    min-width:${props => props.width || 60};
    width:${props => props.width || 100};
    background-color:${props => props.bgColor ? props.bgColor : '#0E3B5F'};
    color: #fff;
    display:block;
    font-weight:bold, 
    height:33px;
    max-height:33px;
    padding-left:10px;
    padding-top:6px;
    position: relative;
    left:0px;   
`;

export { 
    TableContainerYounet,
    TableYounet,
    TheadYounetStyledFixed,
    TheadYounetStyled,
};